
import { customSortPurchaseDate,sortByUseAmt,sortByRemAmt,customSortCrNo,customSortTotalAmount,sortByBaseAmount,customSortPoNo,genericSort,customSortApprovedAmount,sortByIgst,sortBySgst,sortByCgst } from "views/admin/embrillTable/customSort/customSort";

export const expenseDataColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "Po No",
      accessor: "poNo",
      sortType:customSortPoNo
    },
    {
      Header: "Purchase Order Date",
      accessor: "purchasedate",
      sortType:customSortPurchaseDate
    },
    {
      Header: "Category",
      accessor: "category",
      sortType:genericSort

    },
    {
      Header: "Major Type",
      accessor: "majorType",
      sortType:genericSort
    },
    {
      Header: "Minor Type",
      accessor: "minorType",
      sortType:genericSort
    },
    
    {
      Header: "Approved Amount",
      accessor: "approvedAmount",
      sortType:customSortApprovedAmount
    },

  ];

  export const tdsDataColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "Po No",
      accessor: "poNo",
      sortType:customSortPoNo
    },
    {
      Header: "Order Date",
      accessor: "orderdate",
    },
   
    {
      Header: "Total Amount",
      accessor: "totalAmount",
      sortType:customSortTotalAmount
    },
    {
      Header: "Approved Amount",
      accessor: "approvedAmount",
      sortType:customSortApprovedAmount
    },
    
  ];


  export const gstDataColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "PO No",
      accessor: "poNo",
      sortType:customSortPoNo

    },
    {
      Header: "Date",
      accessor: "date",
    },
   
   
    {
      Header: "Base Amount",
      accessor: "baseAmount",
      sortType:sortByBaseAmount

    },
    {
      Header: "IGST Amount",
      accessor: "igstAmt",
      sortType:sortByIgst

    },
    {
      Header: "SGST Amount",
      accessor: "sgstAmt",
      sortType:sortBySgst

    },
    {
      Header: "CGST Amount",
      accessor: "cgstAmt",
      sortType:sortByCgst

    },
    {
      Header: "Total GST",
      accessor: "totalGst",
      sortType:customSortTotalAmount
    },
    
    
  ];

  export const creditDataColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "CR No",
      accessor: "crNo",
      sortType:customSortCrNo
    },
    {
      Header: "Credit Date",
      accessor: "creditDate",
    },
    {
      Header: "PO No",
      accessor: "poNo",
      sortType:customSortPoNo

    },
    {
      Header: "Credit Amount",
      accessor: "creditAmount",
      sortType:customSortTotalAmount
    },
  
    {
      Header: "Used Credit",
      accessor: "usableAmount",
      sortType:sortByUseAmt
    },
    {
      Header: "Available Credit",
      accessor: "remainingAmount",
      sortType:sortByRemAmt
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Actions",
      accessor: "actions",
    },
  
  ];



